import { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { Outlet, useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import HomePage from './HomePage';
import { sponsorService } from '../../firebase/services';

export default function MainLayout() {
  const [sponsors, setSponsors] = useState([]);
  const location = useLocation();

  useEffect(() => {
    const loadSponsors = async () => {
      try {
        const sponsorsData = await sponsorService.getAllSponsors();
        setSponsors(sponsorsData);
      } catch (error) {
        console.error('Erro ao carregar patrocinadores:', error);
        setSponsors([]);
      }
    };

    loadSponsors();
    
    const handleSponsorsUpdated = () => loadSponsors();
    window.addEventListener('sponsorsUpdated', handleSponsorsUpdated);
    return () => window.removeEventListener('sponsorsUpdated', handleSponsorsUpdated);
  }, []);

  return (
    <Box 
      sx={{
        bgcolor: "rgba(94, 106, 108, 0.05)", 
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Header />
      <Box 
        sx={{
          flex: 1,
          overflow: 'auto',
          marginX: {xs: 0, xl:"12vw"},
          paddingTop: '90px', // Espaço para compensar o Header fixo (70px + margem)
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        {location.pathname === '/' ? <HomePage /> : <Outlet />}
      </Box>

      <Footer
        title="Arena Esporte Total"
        description="A sua central de notícias e eventos esportivos."
        site="https://arenaesportetotal.com.br"
        sponsors={sponsors}
      />
    </Box>
  );
}
